export const LinkedinIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='23' height='22' viewBox='0 0 23 22' fill='none'>
    <path
      d='M16.5296 11.7959V15.2004H14.4552V12.0233C14.4552 11.2258 14.1551 10.6816 13.4039 10.6816C12.8309 10.6816 12.4892 11.0481 12.3391 11.4035C12.2849 11.5306 12.2704 11.7075 12.2704 11.8843V15.2004H10.195C10.195 15.2004 10.223 9.82056 10.195 9.26343H12.2704V10.1042L12.2568 10.1236H12.2704V10.1052C12.5463 9.7 13.038 9.12352 14.1406 9.12352C15.5054 9.12352 16.5296 9.97251 16.5296 11.7959ZM8.02378 6.40039C7.31423 6.40039 6.84961 6.84427 6.84961 7.42626C6.84961 7.99724 7.30069 8.45303 7.9967 8.45303H8.01024C8.73429 8.45303 9.18442 7.99626 9.18442 7.42626C9.17087 6.84427 8.73429 6.40039 8.02378 6.40039ZM6.97252 15.2004H9.0479V9.26343H6.97252V15.2004Z'
      fill='#5E6C88'
    />
    <path
      d='M15.9571 2H6.54138C4.28134 2 2.44922 3.86899 2.44922 6.1745V15.4255C2.44922 17.731 4.28134 19.6 6.54138 19.6H15.9571C18.2171 19.6 20.0492 17.731 20.0492 15.4255V6.1745C20.0492 3.86899 18.2171 2 15.9571 2Z'
      stroke='#5E6C88'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
    />
  </svg>
);
